import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { ASSETS } from "../../data/content";

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.04, 1.14]);

  return (
    <section
      id="top"
      ref={ref}
      data-testid="hero-section"
      className="relative h-[100svh] min-h-[600px] overflow-hidden bg-[#052e1e]"
    >
      <motion.div style={{ y, scale }} className="absolute inset-0 will-change-transform">
        <img
          src={ASSETS.hero}
          alt="The Brook at Khanna's Farm — riverside garden"
          fetchPriority="high"
          decoding="async"
          className="h-full w-full object-cover"
        />
      </motion.div>
      {/* Subtle bottom gradient only — keeps the photo in its natural colours */}
      <div className="absolute inset-x-0 bottom-0 h-40 pointer-events-none bg-gradient-to-t from-[#052e1e]/55 to-transparent" />

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 1.8, ease: "easeInOut" }}
          className="text-[#f7f3e9]/85"
        >
          <ChevronDown size={22} />
        </motion.div>
      </div>
    </section>
  );
};
